// src/components/admin/VideoTutorialAdmin.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import HeaderUsuario from "../header/HeaderUsuario";
import backgroundImage from "../../assets/img/FondoDosNuevo.svg";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

const VideoTutorialAdmin = () => {
  const [meta, setMeta] = useState(null); // { url, filename, size, updatedAt }
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const token = localStorage.getItem("token");

  const axiosAuth = axios.create({
    baseURL: API_BASE_URL,
    headers: { Authorization: `Bearer ${token}` },
  });

  const fetchMeta = async () => {
    try {
      setLoading(true);
      const { data } = await axiosAuth.get("/api/tutorial-video");
      setMeta(data || null);
    } catch (err) {
      // si 404 => no hay video aún
      setMeta(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMeta();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("video", file);

    try {
      setUploading(true);
      setProgress(0);
      const { data } = await axiosAuth.post(
        "/api/tutorial-video/upload",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (pe) => {
            if (pe.total) {
              setProgress(Math.round((pe.loaded * 100) / pe.total));
            }
          },
        }
      );
      setMeta(data);
    } catch (err) {
      alert("Error al subir el video. Revisa el formato o el tamaño.");
    } finally {
      setUploading(false);
      setProgress(0);
    }
  };

  const handleDelete = async () => {
    const ok = window.confirm(
      "¿Eliminar el video actual? Esta acción no se puede deshacer."
    );
    if (!ok) return;
    try {
      await axiosAuth.delete("/api/tutorial-video");
      setMeta(null);
    } catch (err) {
      alert("No se pudo eliminar el video.");
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col relative"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute top-4 right-4">
        <HeaderUsuario />
      </div>

      <div className="flex-grow px-6 md:px-16 py-16">
        <h1 className="text-4xl md:text-5xl font-bold text-[#00733A] mb-8">
          Video tutorial — Administración
        </h1>

        <div className="bg-white/80 rounded-2xl shadow-xl p-6 md:p-8 max-w-4xl">
          {/* Estado actual */}
          {loading ? (
            <p className="text-gray-700">Cargando...</p>
          ) : meta ? (
            <div className="space-y-4">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                <div>
                  <p className="font-semibold">
                    Archivo actual:{" "}
                    <span className="font-normal">{meta.filename}</span>
                  </p>
                  {meta.size ? (
                    <p className="text-sm text-gray-600">
                      Tamaño: {(meta.size / (1024 * 1024)).toFixed(2)} MB
                    </p>
                  ) : null}
                  {meta.updatedAt ? (
                    <p className="text-sm text-gray-600">
                      Última actualización:{" "}
                      {new Date(meta.updatedAt).toLocaleString()}
                    </p>
                  ) : null}
                </div>
                <div className="flex gap-3">
                  <label className="inline-flex items-center justify-center px-4 py-2 rounded-xl bg-green-700 text-white cursor-pointer hover:scale-[1.02] transition">
                    Reemplazar video
                    <input
                      type="file"
                      accept="video/mp4,video/webm,video/quicktime"
                      className="hidden"
                      onChange={handleUpload}
                      disabled={uploading}
                    />
                  </label>
                  <button
                    onClick={handleDelete}
                    className="px-4 py-2 rounded-xl bg-red-600 text-white hover:bg-red-700 transition"
                  >
                    Eliminar
                  </button>
                </div>
              </div>

              {uploading && (
                <div className="w-full bg-gray-200 rounded-full h-3">
                  <div
                    className="bg-green-700 h-3 rounded-full transition-all"
                    style={{ width: `${progress}%` }}
                  />
                </div>
              )}

              {/* Vista previa */}
              {meta.url ? (
                <video
                  controls
                  src={meta.url}
                  className="w-full rounded-2xl shadow-lg"
                />
              ) : (
                <p className="text-gray-700">No hay vista previa disponible.</p>
              )}
            </div>
          ) : (
            <div className="space-y-4">
              <p className="text-gray-700">
                Aún no hay un video tutorial cargado.
              </p>
              <label className="inline-flex items-center justify-center px-4 py-2 rounded-xl bg-green-700 text-white cursor-pointer hover:scale-[1.02] transition">
                Subir video
                <input
                  type="file"
                  accept="video/mp4,video/webm,video/quicktime"
                  className="hidden"
                  onChange={handleUpload}
                  disabled={uploading}
                />
              </label>
              {uploading && (
                <div className="w-full bg-gray-200 rounded-full h-3">
                  <div
                    className="bg-green-700 h-3 rounded-full transition-all"
                    style={{ width: `${progress}%` }}
                  />
                </div>
              )}
            </div>
          )}
        </div>

        <p className="text-sm text-gray-600 mt-4">
          * Sugerido: formatos MP4/WebM/MOV. El video se administrará aquí y se
          mostrará en otro lugar de la plataforma.
        </p>
      </div>
    </div>
  );
};

export default VideoTutorialAdmin;
